export default "__VITE_ASSET__Rw$h_vda__"